import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class BreadcrumbsItemComponent extends Component {
  @service breadcrumbs;

  @action
  pushCrumb() {
    //console.log('pushCrumb', this.breadcrumbs);
    this.breadcrumbs.pushCrumb(this);
  }

  @action
  removeCrumb() {
    //console.log('removeCrumb', this.args.text);
    this.breadcrumbs.removeCrumb(this);
  }
}
